/* istanbul ignore file */

const CALLBACK_NAME = 'gmapsCallback';

declare global {
  interface Window {
    google: typeof google;
  }
}

interface CallbackableWindow {
  [CALLBACK_NAME]: () => void;
}

export function initGoogleMaps(googleConfig: { mapsUrl: string; mapsAuth: string }): Promise<typeof google> {
  const GOOGLE_MAPS_API_URL = `${googleConfig.mapsUrl}?${googleConfig.mapsAuth}&libraries=places&callback=${CALLBACK_NAME}`;

  return new Promise((resolve, reject) => {
    if (!!window.google) {
      resolve(window.google);
      return;
    }

    ((window as any) as CallbackableWindow)[CALLBACK_NAME] = () => {
      resolve(window.google);
    };

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = GOOGLE_MAPS_API_URL;
    script.onerror = reject;
    document.querySelector('head')!.appendChild(script);
  });
}
